import React from 'react'

const Main = (props) => {
  return (
    <div id="main-wrapper">
        {props.children}
    </div>
  )
}

export default Main